// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"9150b84a","567":"01a5acbe","651":"57455c88","723":"34d8699d","950":"2003f7b8"}[chunkId] + ".chunk.js";
};